import { render, staticRenderFns } from "./InvoiceClip.vue?vue&type=template&id=55da8984&scoped=true"
import script from "./InvoiceClip.vue?vue&type=script&lang=js"
export * from "./InvoiceClip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55da8984",
  null
  
)

export default component.exports